module.exports = __webpack_public_path__ + "media/5.f0fc8067.mp3";